module.exports = __webpack_public_path__ + "static/media/datagrid-feature-08.be2a37ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/datagrid-feature-08.png
// module id = 1499
// module chunks = 0